import { render, staticRenderFns } from "./bannerCol.vue?vue&type=template&id=aa4386e2&scoped=true&"
import script from "./bannerCol.vue?vue&type=script&lang=js&"
export * from "./bannerCol.vue?vue&type=script&lang=js&"
import style0 from "./bannerCol.vue?vue&type=style&index=0&id=aa4386e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4386e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa4386e2')) {
      api.createRecord('aa4386e2', component.options)
    } else {
      api.reload('aa4386e2', component.options)
    }
    module.hot.accept("./bannerCol.vue?vue&type=template&id=aa4386e2&scoped=true&", function () {
      api.rerender('aa4386e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xcxPos/home/child/bannerCol.vue"
export default component.exports